export const saveAs = (blob: string, fileName: string) => {
  const elem = window.document.createElement('a');
  elem.href = `data:application/vnd.ms-excel;base64,${blob}`;
  elem.download = fileName;
  elem.setAttribute('style', 'display:none;');
  (document.body || document.documentElement).appendChild(elem);
  if (typeof elem.click === 'function') {
    elem.click();
  } else {
    elem.target = '_blank';
    elem.dispatchEvent(
      new MouseEvent('click', {
        view: window,
        bubbles: true,
        cancelable: true,
      })
    );
  }
  URL.revokeObjectURL(elem.href);
  elem.remove();
};

export const objectToFormData = (object: unknown) => {
  const formData = new FormData();
  if (typeof object == 'object') {
    for (const key in object) {
      Array.isArray(object[key as keyof typeof object])
        ? (object[key as keyof typeof object] as Array<string>)?.forEach(
            (value: string | File) => formData.append(key + '[]', value)
          )
        : formData.append(key, object[key as keyof typeof object]);
    }

    return formData;
  }
  return formData;
};

export const formatDate = (date: Date) => {
  const month = (date.getMonth() + 1).toString().padStart(2, '0'); // Months are 0-indexed
  const day = date.getDate().toString().padStart(2, '0');
  const year = date.getFullYear().toString().slice(-2); // Last 2 digits of the year
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'pm' : 'am';
  hours = hours % 12 || 12;
  const formattedDate = `${month}/${day}/${year} ${hours}:${minutes}${ampm}`;
  return formattedDate;
};

enum LOCALE {
  NG = 'en-NG',
  US = 'en-US',
}

export function formatDateTime(date: string) {
  const parsedDate = Date.parse(date);
  if (isNaN(parsedDate)) {
    return 'Invalid Date';
  }

  const formattedDate = new Intl.DateTimeFormat(LOCALE.US, {
    year: '2-digit',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  }).format(parsedDate);

  return formattedDate;
}